<template>
<v-container fluid class="my-0 py-0">
  <v-tabs>
      <v-tab>Usuarios</v-tab>
      <v-tab>Proyectos</v-tab>

      <v-tab-item>
          <Usuarios />
      </v-tab-item>
      <v-tab-item>
          <Proyectos />
      </v-tab-item>
  </v-tabs>
</v-container>
</template>

<script>
import Vue from 'vue'
import Usuarios from './Usuarios.vue'
import Proyectos from './Proyectos.vue'

export default Vue.extend({
    name: 'Administracion',
    components: {
        Usuarios,
        Proyectos
    }
})
</script>

<style>

</style>